import { QueryParams } from "@/models/query-params.model";
import { CrawlerRest } from "@/services/rest/crawler.rest";
import { BehaviorSubject } from "rxjs";

export class TrancriptsService {
  constructor(private _crawler = new CrawlerRest()) {}

  private keywords$ = new BehaviorSubject([]);
  keywords = this.keywords$.asObservable();

  private transcripts$ = new BehaviorSubject([]);
  transcripts = this.transcripts$.asObservable();

  getKeywords(
    transcriptId: string,
    params: Omit<QueryParams, "page" | "size">
  ): void {
    this._crawler.getKeywords(transcriptId, params).subscribe({
      next: (response) => {
        this.keywords$.next(response);
      },
    });
  }

  getTranscripts(
    transcriptId: string,
    params: Omit<QueryParams, "page" | "size">
  ): void {
    this._crawler.getTranscripts(transcriptId, params).subscribe({
      next: (response) => {
        this.transcripts$.next(response);
      },
    });
  }
}
